/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 12:28:56 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListTemplateQuery = gql`
  query allTemplates(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: TemplateFilter
  ) {
    items: allTemplates(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
      variables {
        tag
        description
      }
      content
      ... on EmailTemplate {
        subject
      }
    }
    total: _allTemplatesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;
